import { CustomTag } from "../../../Tags";
import { TagColors } from "../../../Tags/utils/theme";

/**
 * 상품유형 enum
 */
export enum ProductOptionStatus {
  ONE = "단일상품",
  MULTIPLE_SINGLE = "패키지상품",
  MULTIPLE_COMBINATION = "복합상품",
}

/**
 * 상품유형 key type
 */
export type ProductOptionStatusType = keyof typeof ProductOptionStatus;
/**
 * 상품유형별 컬러
 */
export const productOptionStatusTypeColor: {
  [key: string]: TagColors;
} = {
  ONE: "black",
  MULTIPLE_SINGLE: "black",
  MULTIPLE_COMBINATION: "black",
};

interface ProductOptionStatusTagProps {
  value: ProductOptionStatusType;
}

/**
 * 상품유형 태그
 * @param value
 * @returns
 */
export const ProductOptionStatusTag: React.FC<ProductOptionStatusTagProps> = ({
  value,
}) => {
  return (
    <>
      {ProductOptionStatus[value] ? (
        <CustomTag colors={productOptionStatusTypeColor[value]} ghost>
          {ProductOptionStatus[value]}
        </CustomTag>
      ) : (
        "-"
      )}
    </>
  );
};
